export {
  default,
  getServerSideProps,
} from "app/smartphone/[slug]/tips/[article]/page";
